module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-06-14 at 2.08.40 PM (3).992dd387.jpeg";